import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { useLocation, useNavigate } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
}

const BreadcrumbNavigation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // const _params = useParams();
  
  const generateBreadcrumbs = (): BreadcrumbItem[] => {
    const pathSegments = location.pathname.split('/').filter(Boolean);
    const breadcrumbs: BreadcrumbItem[] = [{ label: 'Home', path: '/' }];
    
    let currentPath = '';
    pathSegments.forEach((segment, _index) => {
      currentPath += `/${segment}`;
      
      // Check if it's an ID segment
      const isId = !isNaN(Number(segment));
      
      if (isId) {
        // For ID segments, add the specific entity label
        breadcrumbs.push({
          label: `#${segment}`,
          path: currentPath
        });
      } else {
        // For route segments, format the label
        const formattedLabel = segment
          .split('-')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        
        breadcrumbs.push({
          label: formattedLabel,
          path: currentPath
        });
      }
    });
    
    return breadcrumbs;
  };
  
  const breadcrumbs = generateBreadcrumbs();
  
  const handleClick = (path?: string) => {
    if (path) {
      navigate(path);
    }
  };
  
  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {breadcrumbs.map((crumb, _index) => {
        const isLast = _index === breadcrumbs.length - 1;
        
        if (isLast) {
          return (
            <Typography key={_index} color="text.primary">
              {crumb.label}
            </Typography>
          );
        }
        
        return (
          <Link
            key={_index}
            color="inherit"
            onClick={() => handleClick(crumb.path)}
            sx={{ cursor: 'pointer', '&:hover': { textDecoration: 'underline' } }}
          >
            {crumb.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default BreadcrumbNavigation;